import { Game, GameSession } from "@onmo/graphql/graphql";
import DefaultGame from "../assets/icons/default_game_1x.webp";
import DefaultGame2x from "../assets/icons/default_game_2x.webp";
import DefaultGame3x from "../assets/icons/default_game_3x.webp";
import { getImageWithFallback } from "./game";
import { MAX_WIDTH_TABLET } from "../constants/dimension";
import { PageRoutes } from "../constants/routes";
import { getRoutePath } from "./location";

const isGameSession = (v?: Game | GameSession): v is GameSession =>
  v != null && typeof v === "object" && "game" in v;

const parseMetadata = (meta: unknown): any => {
  if (!meta) return {};
  if (typeof meta === "string") {
    try {
      return JSON.parse(meta);
    } catch {
      return {};
    }
  }
  return typeof meta === "object" ? meta : {};
};

const getContent = (input?: GameSession | Game) => {
  const game: Game | null = isGameSession(input)
    ? input.game ?? null
    : input ?? null;
  const meta = parseMetadata(game?.metadata);

  return {
    src1x:
      getImageWithFallback(meta?.gameImages, "small", "small_aaa") ??
      DefaultGame,
    src2x:
      getImageWithFallback(meta?.gameImages, "small2x", "small_aaa2x") ??
      DefaultGame2x,
    src3x:
      getImageWithFallback(meta?.gameImages, "small3x", "small_aaa3x") ??
      DefaultGame3x,
  };
};

const hideNav = (pathname: string) => {
  return (
    window.innerWidth <= MAX_WIDTH_TABLET && pathname === PageRoutes.Settings
  );
};

export const getPageByPath = (pathname?: string) => {
  const path = pathname || getRoutePath();
  if (path.startsWith(PageRoutes.EssentialPass)) return "Essential Pass";
  if (path.startsWith(PageRoutes.InstallGame)) return "Install & Play";
  if (path.startsWith(PageRoutes.Settings)) return "Settings";
  if (path.startsWith(PageRoutes.Game)) return "Game Details";
  if (path.startsWith(PageRoutes.Search)) return "Search";
  return "";
};

export const NavigationMd = {
  getContent,
  isGameSession,
  hideNav,
};
